import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
    selector: 'app-day-selector',
    templateUrl: './day-selector.component.html',
    styleUrls: ['./day-selector.component.scss'],
    standalone: false
})

export class DaySelectorComponent implements OnInit {
  @Input() public initialSelection: number[] = [];
  @Output() public daysSelected = new EventEmitter<number[]>();
  public daysInMonth: number[];
  public days: number[];

  constructor() { }

  public ngOnInit(): void {
    this.daysInMonth = Array(31);
    this.days = this.initialSelection;
  }

  public toggleDay(day: number): void {
    const index = this.days.indexOf(day);
    if (index > -1) {
      this.days.splice(index, 1);
    } else {
      this.days.push(day);
    }

    this.daysSelected.emit(this.days);
  }
}
